const KEY = "infoboxx_consumer_apply_intent_v1";

export function saveApplyIntent(intent) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(intent || null));
  } catch {
    /* ignore */
  }
}

export function readApplyIntent() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearApplyIntent() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
